export const WC_NAME = 'USA Canada Mexico 2026'
export const OPEN_DATE = {
    computer: '2026-04-01T00:01:00-04:00',
    human: 'April 1st at 12:01am'
}
export const CLOSE_DATE = {
    computer: '2026-06-11T15:00:00-04:00',
    human: 'June 11th at 3:00pm'
}
export const SECOND_OPEN_DATE = {
    computer: '2026-06-28T01:05:00-04:00',
    human: 'June 28th at 1:05am'
}
export const SECOND_CLOSE_DATE = {
    computer: '2026-06-28T15:00:00-04:00',
    human: 'June 28th at 3:00pm'
}
export const TIME_ZONE = 'Eastern Daylight Time (UTC-4)'
export const ABBREV_TIME_ZONE = 'EDT'
